module.exports = __webpack_public_path__ + "img/SALES.fe0ae677.svg";